import { jsx as _jsx } from "react/jsx-runtime";
import Diversity from "../../components/Diversity/Diversity";
var DiversityPage = function () {
    return _jsx(Diversity, {});
};
export default DiversityPage;
